import { useEffect, useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation, useHistory } from "react-router-dom";
import Table from "components/__new/common/Table";
import DownloadAsCSV from "components/__new/common/DownloadAsCSV";
import SortBy from "components/__new/common/SortBy";
import Print from "components/__new/common/Print";
import Pagination from "components/__new/common/pagination";
import SearchBox from "components/__new/common/SearchBox";
import Maybe from "components/__new/common/Maybe";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import DropdownNew from "utils/dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TransactionDetails } from "components/__new/payroll/runPayroll/TransactionDetails";
import { TableContent } from "components/__new/common/TableContent";
import NumberFormat from "utils/numberFormat";
import CurrencyFormat from "utils/currencyFormat";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import processParams from "utils/processParams";
import useUrlNavigation from "hooks/useUrlNavigation";
import { TaxAndDeductionSummary } from "components/__new/payroll/runPayroll/TaxAndDeductionSummary";
import PageContent, { PageContentCustom } from "components/__new/common/PageContent";
import { ReactComponent as IconEdit } from "assets/images/icons/project-icons/edit-pen.svg";
import { ReactComponent as IconLeft } from "assets/images/icons/project-icons/arrow-left.svg";
import { ReactComponent as IconComment } from "assets/images/icons/project-icons/comment.svg";
// import iconAngleDown from "assets/images/icons/icon-angle-down.svg";
// import { ReactComponent as IconSent } from "assets/images/icons/project-icons/sent.svg";
import { PayrollMetrics } from "components/__new/payroll/runPayroll/PayrollMetrics";
import logger from "utils/logger";
import useLoginInfo from "hooks/useLoginInfo";
import * as payrollAction from "store/entities/payroll/runPayroll/action";
import * as walletAction from "store/entities/wallet/action";
import usePayrollEssentials from "hooks/usePayrollEssentials";
import DateFormat, { DaysLeft } from "utils/dateFormat";
// import { Menu } from "@headlessui/react";
import RequestAccessPin from "components/__new/common/access-pin/RequestAccessPin";
import ModalAlert from "components/__new/common/ModalAlert";
import { ButtonLoader } from "components/__new/common/form";
import { transformPayrollName } from "utils/payroll/transformPayrollName";
import useInlinePageRouter from "components/__new/general/useInlinePageRouter";


const Index = () => {
    const {id} = useParams();
    const location = useLocation();
    const dispatch = useDispatch();
    const {urlQuery} = useUrlNavigation();
    const {urlQueryParams} = useUrlQueryParams();
    const {userInfo} = useLoginInfo();
    const history = useHistory();
    const {getPayrollStatusStyle} = usePayrollEssentials();

    const {
        payrollLoading, payroll, payrollSalaryPaymentLoading, payrollSalaryPayment,
        payrollTransactionsLoading, payrollTransactions, payrollTransactionsDownloadLoading, payrollTransactionsDownload,
    } = useSelector((s) => s.entities.runPayroll);
    const { dashboardLoading: walletDashboardLoading, dashboard: walletDashboard } = useSelector((s) => s.entities.wallet);


    const downloadAsCSVRef = useRef();
    const printComponentRef = useRef();
    
    const paginationData = useMemo(() => {
        if (!payrollTransactions?.data) return {};
        
        const { data, ...paginationInfo } = payrollTransactions;
        return paginationInfo;
    }, [payrollTransactions])


    const [view, setView] = useState("Payee List");
	const { InlineRouterTab } = useInlinePageRouter("Payee List");
    const [isOpenEmployeeDetails, setIsOpenEmployeeDetails] = useState(false);
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });
    const [sortOptions, setSortOptions] = useState([
        {
            title: <>Date Created <FontAwesomeIcon icon="arrow-up" className="ml-2 mt-0.5" /></>,
            link: urlQuery("sort=createdAt&order=asc"),
            data: {sort: 'createdAt', order: 'asc'},
            active: false,
        },
        {
            title: <>Date Created <FontAwesomeIcon icon="arrow-down" className="ml-2 mt-0.5" /></>,
            link: urlQuery("sort=createdAt&order=desc"),
            data: {sort: 'createdAt', order: 'desc'},
            active: false,
        },
    ]);
    const [transaction, setTransaction] = useState({});
    const [isCommentShown, setIsCommentShown] = useState(false);
    const [form, setForm] = useState({
        // date: "",
        // time: "",
        accessPin: "",
    });
    const [payrollCharge, setPayrollCharge] = useState(null);
    const [isOpenAccessPin, setIsOpenAccessPin] = useState(false);
    const [isOpenModalAlertPaySalarySuccess, setIsOpenModalAlertPaySalarySuccess] = useState(false);


    const viewEmployeeDetails = (transaction) => {
        setTransaction(transaction);
        setIsOpenEmployeeDetails(true);
    }


    const getPayrollDetails = () => {
        dispatch(payrollAction.getPayrollDetails(id));
    }


    const calculatePayrollCharge = () => {
        if (payroll?.transaction_metrics?.total_cost !== undefined && payroll?.transaction_metrics?.total_fee !== undefined){
            setPayrollCharge(payroll?.transaction_metrics?.total_cost + payroll?.transaction_metrics?.total_fee);
        }
    }


    const resetPaySalary = () => {
        dispatch(payrollAction.resetPaySalary());
    }


    const getWalletDetails = () => {
        if (walletDashboardLoading === false && (walletDashboard?.status === undefined || walletDashboard?.status === "failed")){
            dispatch(walletAction.getDashboardSilent(userInfo.token));
        }
    }


    const processForm = () => {
        const params = {
            month: payroll?.schedule?.month,
            year: payroll?.schedule?.year.toString(),
            access_pin: form.accessPin,
        }
        logger("Employer-payroll-runpayroll-paysalaries-attempt", userInfo)
        logger("Employer-payroll-runpayroll-paysalaries-sucess", userInfo)
        dispatch(payrollAction.paySalary(id, params));
    }


    const getPayrollTransactions = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "search", "string", "", "searchQuery");
        params = processParams(urlQueryParams, params, "sort", "string", "", "sortBy");
        params = processParams(urlQueryParams, params, "order", "string", "", "sortOrder");

        const sortValue = urlQueryParams["sort"];
        const orderValue = urlQueryParams["order"];
        if (sortValue && orderValue) {
            const newSortOptions = sortOptions?.map((sortOption) => {
                if (sortOption?.data?.sort === sortValue && sortOption?.data?.order === orderValue) {
                    return {...sortOption, active: true};
                }
                else {
                    return {...sortOption, active: false};
                }
            })
            setSortOptions(newSortOptions);
        }

        setListParams(params);
        dispatch(payrollAction.getPayrollTransactions(id, params));
    }


    useEffect(() => {
        if (id){
            getPayrollDetails();
        }
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        if (payroll?.id !== undefined){
            getPayrollTransactions();
            calculatePayrollCharge();
        }
        // eslint-disable-next-line
    }, [payroll, location]);



    useEffect(() => {
        if (payrollSalaryPayment?.status === "success"){
            setIsOpenAccessPin(false);
            setIsOpenModalAlertPaySalarySuccess(true);
            resetPaySalary();
            getPayrollDetails();
            getWalletDetails();
        }
        // eslint-disable-next-line
    }, [payrollSalaryPayment]);

    return (
        <div>


            <DynamicHeadTag
                headerText={id + " - Finalize Payroll"}
                headerDescription=""
            />


            <TransactionDetails
                isOpen={isOpenEmployeeDetails}
                setIsOpen={setIsOpenEmployeeDetails}
                transaction={transaction}
            />



            <ModalAlert
                successText="Salary payment successful"
                dismissText="Close"
                isOpenModalAlert={isOpenModalAlertPaySalarySuccess}
                setIsOpenModalAlert={setIsOpenModalAlertPaySalarySuccess}
            />



            <RequestAccessPin
                target="Access Pin"
                title="Validate Transfer"
                description="Enter Access Pin"
                showForgotPin={true}
                footnote={
                    <span className="text-sm text-[#4A5564]">
                        By clicking “Continue” you authorize a deduction of&nbsp;
                        <span className="text-ep-primary font-semibold">
                            {CurrencyFormat(payrollCharge)}
                        </span>
                        &nbsp;from your Account Balance
                    </span>
                }
                pin={(e) => setForm({...form, accessPin: e})}
                submit={() => {
                    processForm();
                }}
                loading={payrollSalaryPaymentLoading}
                modalLoading={false}
                isOpenPin={isOpenAccessPin}
                setIsOpenPin={setIsOpenAccessPin}
            />


            {/* <PayRemittances
                isOpen={isOpenPayRemittances}
                setIsOpen={setIsOpenPayRemittances}
                payroll={payroll}
            /> */}
            
            <div className="mt-3 lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title flex items-center">
                        <div className="flex items-center justify-center bg-[#ECECEC] h-12 rounded-xl" style={{ width: "3.5rem" }}>
                            <IconLeft 
                                className="text-2xl cursor-pointer w-6 h-6" 
                                // onClick={() => history.push("/payroll")} 
                                onClick={() => {
                                    history.goBack();
                                }} 
                            />
                        </div>
                        <span className="font-medium ml-3 capitalize">{payroll?.name?.includes("_") ? transformPayrollName(payroll?.name || "-") : payroll?.name}</span>
                    </div>
                </div>
                
                <Maybe condition={payrollLoading === false}>
                    
                    <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end pr-5">
                        
                        {/* <ButtonLoader loading={payrollLoading} disabled={payroll?.status === "completed" || payroll?.status === "processing"} onClick={() => setIsOpenAccessPin(true)} className="btn btn-md btn-ep-primary disabled:text-gray-300 disabled:cursor-not-allowed">
                            Pay Salaries
                        </ButtonLoader> */}
                        
                        {/* <button className="text-ep-primary-500 flex items-center">
                            Send Payslips 
                            <span className="ml-1">
                                <IconSent />
                            </span>
                        </button>
                        
                        <div className="mx-6">
                            <Menu as="div">
                                <Menu.Button as="div" className="h-full btn px-3 text-sm border border-gray-400 cursor-pointer whitespace-nowrap">
                                    <span>Download</span>
                                    <img src={iconAngleDown} alt="arrow" className="h-5 m-auto object-contain" />
                                </Menu.Button>
                                <Menu.Items className="dropdown">
                                    <Menu.Item>
                                        <>
                                            <button disabled className="dropdown-item w-full whitespace-nowrap disabled:text-gray-300 disabled:cursor-not-allowed">
                                                Download Payslips
                                            </button>
                                            <button disabled className="dropdown-item w-full whitespace-nowrap disabled:text-gray-300 disabled:cursor-not-allowed">
                                                Download Bank Advice
                                            </button>
                                            <button disabled className="dropdown-item w-full whitespace-nowrap disabled:text-gray-300 disabled:cursor-not-allowed">
                                                Download Remittance
                                            </button>
                                        </>
                                    </Menu.Item>
                                </Menu.Items>
                            </Menu>
                        </div>
                        
                        <div className="relative">
                            <Menu as="div">
                                <Menu.Button as="div" className="h-full btn px-3 text-sm border border-gray-400 cursor-pointer whitespace-nowrap">
                                    <span>Pay</span>
                                    <img src={iconAngleDown} alt="arrow" className="h-5 m-auto object-contain" />
                                </Menu.Button>
                                <Menu.Items className="dropdown absolute right-0">
                                    <Menu.Item>
                                        <>
                                            <Maybe condition={payroll?.status !== "completed"}>
                                                <button onClick={() => setIsOpenAccessPin(true)} className="w-full dropdown-item whitespace-nowrap disabled:text-gray-300 disabled:cursor-not-allowed">
                                                    Pay Salaries
                                                </button>
                                            </Maybe>
                                            
                                            
                                            <button disabled className="dropdown-item flex items-center whitespace-nowrap disabled:text-gray-300 disabled:cursor-not-allowed">
                                                Pay Remittance
                                                <span className="ml-1.5 label !px-2 text-white bg-ep-secondary !text-[0.65rem] rounded-full">
                                                    Coming Soon
                                                </span>
                                            </button>
                                        </>
                                    </Menu.Item>
                                </Menu.Items>
                            </Menu>
                        </div> */}
                    </div>
                </Maybe>
            </div>
            
            <Maybe condition={payrollLoading === false}>
                <div className="flex items-center justify-start mt-5 mb-4">
                    {/* <div className="mt-4 mb-3 flex items-center text-sm">
                        <span>Status:&nbsp;</span>
                        <label className={"py-1 px-2 w-max flex items-center justify-center rounded-full capitalize text-xs " + getPayrollStatusStyle(payroll?.status)}>
                                {payroll?.status}
                        </label>
                    </div> */}
                    
                    <Maybe condition={payroll?.comment}>
                        <div className="">
                            <span onClick={() => setIsCommentShown(!isCommentShown)} className="flex items-center text-right text-ep-primary whitespace-nowrap cursor-pointer hover:underline text-sm">
                                {isCommentShown ? "Hide" : "See"} Comment
                                <IconComment className="ml-2" />
                            </span>
                        </div>
                    </Maybe>
                </div>
            </Maybe>
            
            <Maybe condition={isCommentShown === true}>
                <Maybe condition={payroll?.status === "approved" || payroll?.status === "completed" || payroll?.status === "processing"}>
                    <div className="px-4 py-2 my-4 bg-ep-primary-100 rounded-lg w-full lg:w-2/5 capitalize">
                        {payroll?.comment ?? "-"}
                    </div>
                </Maybe>
                <Maybe condition={payroll?.status === "rejected"}>
                    <div className="px-4 py-2 my-4 bg-[#FEF2F2] rounded-lg w-full lg:w-2/5 capitalize">
                        {payroll?.comment ?? "-"}
                    </div>
                </Maybe>
            </Maybe>
            
            <Maybe condition={payrollLoading === false && payroll?.id !== undefined}>
                {/* <div className="flex flex-wrap mt-3">
                    <div className="mr-4 mb-4">
                        Payroll selection:
                        <span className="ml-2 text-ep-primary font-medium">
                            <Maybe condition={payroll?.pay_selection === "ALL_EMPLOYEES"}>
                                All Employees
                            </Maybe>
                            <Maybe condition={payroll?.pay_selection === "PAY_GROUPS"}>
                                {payroll?.metadata?.pay_groups?.map((pay_group, index) => {
                                    let data = "";
                                    if (index > 0){
                                        data += ", ";
                                    }
                                    data += pay_group?.name;
                                    return data;
                                })}
                                {!payroll?.metadata?.pay_groups && <span>Pay Groups</span>}
                            </Maybe>
                        </span>
                    </div>
                    <div className="mr-4 mb-4">
                        Payroll month:
                        <span className="w-max px-2 py-2 font-medium text-ep-primary rounded-md">
                            {monthNames[payroll?.schedule?.month -1] || "-"} {payroll?.schedule?.year}
                        </span>
                    </div>
                    <div className="mr-4 mb-4">
                        Period:
                        <span className="ml-2 text-ep-secondary-600">
                            {DateFormat(payroll?.payroll_date_range?.start_date) || "-"}
                            &nbsp;-&nbsp;
                            {DateFormat(payroll?.payroll_date_range?.end_date) || "-"}
                        </span>
                    </div>
                </div> */}
                <div className="flex flex-col lg:flex-row mb-8 py-6 px-4 bg-white rounded-xl payroll-info-card flex-wrap gap-6">
                    <div className="w-max px-3 lg:pr-6 lg:border-r border-gray-200 lg:mb-0 pl-0">
                        <div className="text-base text-[#718096]">
                            Payroll Date
                        </div>
                        <div className="mt-2 text-sm font-medium bg-[#F2F4F7] rounded-2xl px-3 py-1 text-[#344054] w-fit" style={{ marginLeft: "-2px" }}>
                            {DateFormat(payroll?.payroll_date_range?.end_date) || "-"}
                        </div>
                    </div>
                    <div className="w-max px-3 pl-0 lg:pr-6 lg:border-r border-gray-200 lg:mb-0">
                        <div className="text-base text-[#718096]">
                            Period
                        </div>
                        <div className="mt-2 text-sm font-medium bg-[#F2F4F7] rounded-2xl px-3 py-1 text-[#344054] w-fit" style={{ marginLeft: "-2px" }}>
                            {DateFormat(payroll?.payroll_date_range?.start_date) || "-"}
                            &nbsp;-&nbsp;
                            {DateFormat(payroll?.payroll_date_range?.end_date) || "-"}
                        </div>
                    </div>
                    <div className="w-max px-3 pl-0 lg:pr-6 lg:border-r border-gray-200 lg:mb-0">
                        <div className="text-base text-[#718096]">
                            Days Left
                        </div>
                        <div className="mt-2 text-sm font-medium bg-[#F2F4F7] rounded-2xl px-3 py-1 text-[#344054] w-fit" style={{ marginLeft: "-2px" }}>
                            {DaysLeft(payroll?.payroll_date_range?.end_date) || "-"}
                        </div>
                    </div>
                    <div className="w-max px-3 pl-0 lg:pr-6 lg:border-r border-gray-200 lg:mb-0">
                        <div className="text-base text-[#718096]">
                            Payroll Status
                        </div>
                        <div className={`mt-2 text-sm font-medium capitalize rounded-2xl px-3 py-1 w-fit ${getPayrollStatusStyle(payroll?.status)}`} style={{ marginLeft: "-2px" }}>
                            {payroll?.status}
                        </div>
                    </div>
                    <div className="flex flex-col items-start lg:items-center justify-center">
                        <ButtonLoader loading={payrollLoading} disabled={payroll?.status === "completed" || payroll?.status === "processing"} onClick={() => setIsOpenAccessPin(true)} className="btn btn-md btn-ep-primary disabled:text-gray-300 disabled:cursor-not-allowed">
                            Pay Salaries
                        </ButtonLoader>
                    </div>
                </div>
            </Maybe>
            


            <PageContent
                loading={payrollLoading}
                data={payroll?.id}
                classes="mt-6 box"
                loadingText="Loading payroll data"
                emptyText="Payroll data not found"
                errorText="Unable to load payroll data"
            />

            <Maybe condition={payrollLoading === false && payroll?.id !== undefined}>
                <Maybe condition={!(payroll?.status === "approved" || payroll?.status === "processing" || payroll?.status === "completed")}>
                    <PageContentCustom
                        icon="exclamation-triangle"
                        classes="mt-6 box"
                        text="Access Denied"
                    />
                </Maybe>

                <Maybe condition={payroll?.status === "approved" || payroll?.status === "processing" || payroll?.status === "completed"}>  
                    <PayrollMetrics
                        loading={false}
                        data={payroll}
                    />

                    <div className="mt-12 border-b">
                        {/* <TabSettings options={[
                            {
                                title: <span>Payee List</span>,
                                type: "div",
                                isActive: (view === "Payee List" ? true : false),
                                onclick: () => setView("Payee List"),
                            },
                            {
                                title: <span>Tax & Deduction Summary</span>,
                                type: "div",
                                isActive: (view === "Tax & Deduction Summary" ? true : false),
                                onclick: () => setView("Tax & Deduction Summary"),
                            },
                        ]} /> */}
                        <div className="flex items-center">
                            <InlineRouterTab
                                tabMode
                                defaultTab={view}
                                onTabChange={(activeItem) => setView(activeItem)}
                                containerClassName="w-1/2"
                                items={[
                                    {
                                        title: "Payee List",
                                        value: "Payee List",
                                    },
                                    {
                                        title: "Tax & Deduction Summary",
                                        value: "Tax & Deduction Summary",
                                    },
                                ]}
                            />
                        </div>
                    </div>


                    <Maybe condition={view === "Payee List"}>
                        <div className="mt-6 box">

                            <div className="flex flex-wrap justify-between">
                                <div className="max-w-sm flex-grow sm:mr-6">
                                    <div className="h-10 flex lg:items-center">
                                        <SearchBox placeholder="Search payees..." name="search" extraUrlParams="page=1" />
                                    </div>
                                </div>
                                <div className="flex flex-wrap space-x-3 sm:space-x-6">
                                    <div className="relative flex justify-end payroll-sortby" style={{ width: "200px" }}>
                                        <SortBy options={sortOptions} title=" " firstOption="Sort by" />
                                    </div>
                                    
                                    <div>
                                        <DownloadAsCSV
                                            ref={downloadAsCSVRef}
                                            tooltip="Download payee list"
                                            filename="Payee list.csv"
                                            columns={[
                                                { label: "Employee name", key: "employee_name" },
                                                { label: "Employee number", key: "employee_number" },
                                                { label: "Workdays", key: "days_worked"},
                                                { label: "Gross Pay", key: "gross_pay" },
                                                { label: "Net Pay", key: "net_pay" },
                                                { label: "On-demand Pay", key: "on_demand_pay" },
                                                { label: "Manual Deductions", key: "manual_deductions" },
                                                { label: "Manual Bonus", key: "manual_bonuses" },
                                                { label: "Custom", key: "" },
                                                { label: "Pension", key: "pension_deduction.employee_amount" },
                                                { label: "NHF", key: "nhf" },
                                                { label: "NSITF", key: "nsitf" },
                                                { label: "ITF", key: "itf" },
                                                { label: "Status", key: "status" },
                                            ]}
                                            click={() => {
                                                dispatch(payrollAction.downloadPayrollTransactions(id, {...listParams, page: 1, limit: 2000})).then(() => {
                                                    downloadAsCSVRef.current?.downloadData();
                                                });
                                            }}
                                            loading={payrollTransactionsDownloadLoading}
                                            response={payrollTransactionsDownload?.data}
                                        />
                                    </div>

                                    <div>
                                        <Print component={printComponentRef} />
                                    </div>
                                </div>
                            </div>

                            
                            <div className="mt-6">
                                <div ref={printComponentRef}>

                                    <div className="mb-4 text-xl hidden print:block">
                                        Payee List
                                    </div>
                                    
                                    <Table>
                                        <Table.Head>
                                            <th>Name</th>
                                            <th>Workdays</th>
                                            <Maybe condition={payroll?.type === "GROSS"}>
                                                <th>Gross Pay </th>
                                            </Maybe>
                                            <th>Net Pay</th>
                                            <th>On-demand Pay</th>
                                            <th>Custom Deductions</th>
                                            <th>Custom Bonus</th>
                                            <th>Custom</th>
                                            <Maybe condition={payroll?.type === "GROSS"}>
                                                <th></th>
                                            </Maybe>
                                        </Table.Head>
                                        <Table.Body>

                                            <TableContent
                                                loading={payrollTransactionsLoading}
                                                loadingText="Loading payroll transactions"
                                                data={payrollTransactions}
                                                colspan={10}
                                            />

                                            {payrollTransactionsLoading === false && payrollTransactions?.data?.map((payrollTransaction) =>
                                                <tr key={payrollTransaction?.id}>
                                                    <td>
                                                        <div className="font-medium capitalize">
                                                            {payrollTransaction?.employee_name || "-"}
                                                        </div>
                                                        <Maybe condition={payrollTransaction?.employee_number && payrollTransaction?.employee_number !== ""}>
                                                            <div className="text-fade">
                                                                {payrollTransaction?.employee_number}
                                                            </div>
                                                        </Maybe>
                                                    </td>
                                                    <td className="text-fade-3">
                                                        {NumberFormat(payrollTransaction?.days_worked, "no-kobo") || "-"}
                                                    </td>
                                                    <Maybe condition={payroll?.type === "GROSS"}>
                                                        <td className="text-fade-3">
                                                            {CurrencyFormat(payrollTransaction?.gross_pay, "no-kobo") || "-"}
                                                        </td>
                                                    </Maybe>
                                                    <td className="text-fade-3">
                                                        {CurrencyFormat(payrollTransaction?.net_pay, "no-kobo") || "-"}
                                                    </td>
                                                    <td className="text-fade-3">
                                                        {CurrencyFormat(payrollTransaction?.on_demand_pay, "no-kobo") || "-"}
                                                    </td>
                                                    <td className="text-fade-3">
                                                        {CurrencyFormat(payrollTransaction?.manual_deductions, "no-kobo") || "-"}
                                                    </td>
                                                    <td className="text-fade-3">
                                                        {CurrencyFormat(payrollTransaction?.manual_bonuses, "no-kobo") || "-"}
                                                    </td>
                                                    <td className="text-fade-3">
                                                        {/* ₦0.00 */}
                                                        -
                                                    </td>
                                                    <Maybe condition={payroll?.type === "GROSS"}>
                                                        <td>
                                                            <DropdownNew>
                                                                <></>
                                                                <div>
                                                                    <div onClick={() => viewEmployeeDetails(payrollTransaction)} className="dropdown-item dropdown-item-icon">
                                                                        <IconEdit />
                                                                        View Details
                                                                    </div>
                                                                </div>
                                                            </DropdownNew>
                                                        </td>
                                                    </Maybe>
                                                </tr>
                                            )}

                                        </Table.Body>
                                    </Table>

                                    <Maybe condition={payrollTransactionsLoading === false && payrollTransactions?.data?.length > 0}>
                                        <div className="mt-6">
                                            <Pagination data={paginationData} limit={paginationData?.limit} />
                                        </div>
                                    </Maybe>

                                </div>
                            </div>
                        </div>
                    </Maybe>


                    <Maybe condition={view === "Tax & Deduction Summary"}>
                        <div className="mt-6 px-0 box">
                            <TaxAndDeductionSummary
                                id={id} 
                                payroll={payroll}
                            />
                        </div>
                    </Maybe>
                    
                </Maybe>
            </Maybe>


        </div>
    )
}


export default Index;